<script setup>
import { scrollToTitle } from "@/composables/commonFunction.js";
const seoTitle = "MIRASOFT - Technology";
const seoDescription = "";

useHead({
  title: seoTitle,
  meta: [
    { name: "description", content: seoDescription },
    { name: "og:title", content: seoTitle },
    { name: "og:description", content: seoDescription },
    { name: "keywords", content: "Technology" },
  ],
});

const listTag = [
  {
    title: "CHATBOT",
  },
  {
    title: "ai",
  },
  {
    icon: "/images/cube-1.svg",
  },
  {
    title: "UI/UX DESIGN",
  },
];
const listTag1 = [
  {
    title: "MLOPS",
  },
  {
    icon: "/images/abstract-1.svg",
  },
  {
    title: "PROCESSING",
  },
  {
    title: "PYTHON",
  },
  {
    title: "DAGS",
  },
];
</script>

<template>
  <div class="home-page px-12 max-md:px-6 py-10">
    <section id="about-us" class="2xl:container m-auto max-md:pt-4">
      <div class="max-sm:hidden" data-aos="fade-up">
        <nuxt-picture
          loading="lazy"
          src="/images/banner/frame-86.png"
          :imgAttrs="{ class: 'w-full', alt: 'home-banner' }"
          class="w-full"
        />
      </div>
      <div class="sm:hidden -mx-4" data-aos="fade-up">
        <nuxt-picture
          loading="lazy"
          src="/images/banner/frame-87.png"
          :imgAttrs="{ class: 'w-full', alt: 'home-banner-mobile' }"
          class="w-full"
        />
      </div>
    </section>

    <section class="mt-[80px] 2xl:container m-auto" id="artificial-intelligence-ai">
      <div class="flex max-lg:flex-col max-md:items-center gap-4">
        <div
          class="w-[55%] bg-white rounded-3xl overflow-hidden p-16 relative max-xl:p-4 max-lg:w-full"
          data-aos="fade-right"
        >
          <div class="flex max-md:flex-col gap-[32px] items-center max-md:items-start">
            <nuxt-picture
              loading="lazy"
              src="/images/lllustration-shapes.svg"
              :imgAttrs="{ alt: 'icon' }"
              class="w-[60px] max-md:w-[60px]"
            />
            <p class="uppercase text-[32px] max-md:text-[24px] font-semibold">miu Production ai Platform</p>
          </div>
          <div class="pt-[10px] font-medium max-md:text-[12px] text-[16px] uppercase">AI solutions, UI/UX Design</div>
          <div class="text-justify">
            <h4 class="text-[#101010] pt-[10px] max-md:text-[18px]">ABOUT</h4>
            <p class="text-[18px] max-md:text-[14px] text-black pt-[20px]">
              <strong class="text-[18px] max-md:text-[14px]">Miu</strong> is a serverless MLops platform for AI engieers
              to quickly deploy and intergrate their AI models with the applications, on a large scale, distributed
              cloud system. Specially designed for applying AI in streaming applications, Miu can be used for image,
              video and audio processing with AI engines, allow creating complex, dynamic process graph, while maintain
              the high performance, low latency and high throughout, support scaling from zero to large cluster based on
              demand.
            </p>
          </div>
          <div class="text-justify">
            <h4 class="text-[#101010] pt-[10px] uppercase max-md:text-[18px]">Scope of Work</h4>
            <p class="text-[18px] text-black pt-1 max-md:text-[14px]">
              - Design and implement the MLOps platform that allows AI Engineers to define and deploy AI engines as
              serverless Python functions. 
            </p>
            <p class="text-[18px] text-black pt-1 max-md:text-[14px]">
              - The platform must allow users to define complex processing DAGs that is  composed of multiple AI
              engines.
            </p>
            <p class="text-[18px] text-black pt-1 max-md:text-[14px]">
              - Manage the user sessions, with status, input and outputs - Manage the usage, and apply a limit for each
              user.
            </p>
          </div>
        </div>
        <div class="w-[45%] max-lg:w-full rounded-3xl overflow-hidden max-md:mt-3" data-aos="fade-left">
          <div>
            <nuxt-picture
              loading="lazy"
              src="/images/group-94.png"
              class="w-full picture"
              :imgAttrs="{ class: 'w-full max-xl:h-full max-2xl:h-[450px]', alt: 'cammera' }"
            />
          </div>
          <div class="flex max-lg:flex-col gap-4 mt-4 max-md:mt-7">
            <div class="w-full max-lg:w-full bg-[#F67D30] p-6 rounded-3xl" data-aos="fade-up" data-aos-delay="300">
              <div class="flex flex-wrap gap-2 ml-[10px]">
                <div v-for="tag in listTag">
                  <div v-if="tag.title" class="border boroder-[#0B0B0B] px-[27px] py-[10.5px] rounded-3xl uppercase">
                    <p class="text-white text-[14px] max-md:text-[12px] font-semibold">{{ tag.title }}</p>
                  </div>
                  <div
                    v-else
                    class="w-[42px] h-[42px] rounded-[50%] border boroder-[#0B0B0B] flex justify-center items-center"
                  >
                    <nuxt-picture loading="lazy" :src="tag.icon" width="100%" :imgAttrs="{ alt: 'icon' }" />
                  </div>
                </div>
              </div>
              <div class="flex flex-wrap gap-2 mt-[12px] ml-[10px]">
                <div v-for="tag in listTag1">
                  <div v-if="tag.title" class="border boroder-[#0B0B0B] px-[27px] py-[10.5px] rounded-3xl uppercase">
                    <p class="text-white font-semibold text-[14px] max-md:text-[12px]">{{ tag.title }}</p>
                  </div>
                  <div
                    v-else
                    class="w-[42px] h-[42px] rounded-[50%] border boroder-[#0B0B0B] flex justify-center items-center"
                  >
                    <nuxt-picture loading="lazy" :src="tag.icon" width="100%" :imgAttrs="{ alt: 'icon' }" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="mt-[80px] 2xl:container m-auto max-md:mt-8" id="augmented-reality-ar">
      <div class="flex max-lg:flex-col max-md:items-center gap-4">
        <div class="w-[45%] max-lg:w-full rounded-3xl overflow-hidden max-lg:order-1 max-md:mt-4" data-aos="fade-right">
          <nuxt-picture
            loading="lazy"
            src="/images/1.png"
            class="w-full picture"
            :imgAttrs="{ class: 'w-full max-xl:h-[800px] max-lg:h-full max-2xl:h-[800px]', alt: 'cammera' }"
          />
        </div>
        <div
          class="w-[55%] bg-white rounded-3xl overflow-hidden p-10 relative max-xl:p-4 max-lg:w-full"
          data-aos="fade-left"
        >
          <div class="flex max-md:flex-col gap-[32px] items-start">
            <nuxt-picture loading="lazy" src="/images/group-50.svg" :imgAttrs="{ alt: 'icon' }" class="w-[110px]"/>
            <p class="uppercase font-bold text-[32px] max-md:text-[24px]">
              REAL-TIME FACE DETECTION FOR WEB VIDEO CALL AR APPLICATION
            </p>
          </div>
          <div class="pb-[18px] font-medium text-[16px] uppercase max-md:text-[12px] max-md:mt-5">Ar solutions</div>
          <div class="mb-[20px]">
            <h4 class="text-[#101010] font-bold pt-[10px] uppercase mb-[18px] max-md:text-[18px]">Technologies</h4>
            <div class="ml-6">
              <p class="text-[18px] text-black pt-[10px] max-md:text-[14px] max-md:pt-0">
                - Face and facial landmark detection model: Pyroch, ONNX
              </p>
              <p class="text-[18px] text-black pt-[10px] max-md:text-[14px]">- Process WebRTC live video stream</p>
              <p class="text-[18px] text-black pt-[10px] max-md:text-[14px]">- Application: FastAPI, MongoDB, React</p>
              <p class="text-[18px] text-black pt-[10px] max-md:text-[14px]">- Cloud: K8S, AWS</p>
              <p class="text-[18px] text-black pt-[10px] max-md:text-[14px]">- Monitoring: Grafana, Loki, Tempo</p>
              <p class="text-[18px] text-black pt-[10px] max-md:text-[14px]">- Built with Miu Platform</p>
            </div>
          </div>
          <div class="flex max-md:flex-col max-md:items-start items-center gap-[42.84px] max-md:gap-4 mt-[20px]">
            <h4 class="text-black font-bold uppercase max-md:text-[18px]">Development Time</h4>
            <p class="text-right text-black text-[18px] max-md:text-[14px] max-md:text-left">3 months</p>
          </div>
          <div class="flex max-md:flex-col max-md:items-start items-center gap-[35.35px] max-xl:gap-3 mt-[20px]">
            <h4 class="text-black font-bold uppercase max-md:text-[18px]">Team Size</h4>
            <p class="text-right text-black text-[18px] max-md:text-left max-md:text-[14px]">
              9 (1 PM, 1 Tech Lead, 3 Developers, 1 DevOps, 3 AI)
            </p>
          </div>
          <div class="mt-[20px]">
            <h4 class="text-[#101010] pt-[10px] uppercase">Scope of Work</h4>
            <p class="text-[18px] text-black pt-3 max-md:text-[14px]">
              - Implement a real-time face detection and landmark estimation on live video stream from WebCam
            </p>
            <p class="text-[18px] text-black pt-2 max-md:text-[14px]">
              - Real-time processing on server side, and stream live video to the client via WebRTC. This allow
              applications that have server-to-client video processing on server.
            </p>
            <p class="text-[18px] text-black pt-2 max-md:text-[14px]">
              - Apply AR decoration to the face and display on React app.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="mt-[80px] 2xl:container m-auto max-md:mt-5" id="amr-agv">
      <section class="mt-[80px] 2xl:container m-auto max-md:mt-0">
        <div class="flex max-lg:flex-col max-md:items-center gap-4">
          <div
            class="w-[55%] bg-white rounded-3xl overflow-hidden p-16 relative max-xl:p-4 max-lg:w-full"
            data-aos="fade-right"
          >
            <div class="flex max-md:flex-col gap-[32px] items-start">
              <nuxt-picture
                loading="lazy"
                src="/images/lllustration-shapes.svg"
                :imgAttrs="{ alt: 'icon' }"
                class="w-[93px]"
              />
              <p class="uppercase text-[32px] max-md:text-[24px] font-bold">
                AUTONOMOUS MOBILE ROBOT PLATFORM (AMR/AGV)
              </p>
            </div>
            <div class="pt-[10px] font-medium text-[16px] max-md:text-[12px] uppercase">AMR/AGV Platform</div>
            <div class="">
              <h4 class="text-[#101010] pt-[20px] max-md:[18px]">About Client</h4>
              <p class="text-[18px] text-black pt-[20px] max-md:text-[14px]">
                Our client approached us with the vision of creating a revolutionary line-free AMR platform to optimize
                their internal logistics and increase efficiency in their operations. The primary objectives of the
                project were to design a robust and adaptable AMR/AGV system capable of:
              </p>
              <p class="text-[18px] max-md:text-[14px] mt-[5px]">
                - <strong class="text-[18px] max-md:text-[14px]">Navigating Without Magnetic Lines</strong>: We embraced
                the challenge of developing an adva nced solution that could move autonomously without the need for such
                markers.
              </p>
              <p class="text-[18px] max-md:text-[14px] mt-[5px]">
                - <strong class="text-[18px] max-md:text-[14px]">Utilizing LIDAR Sensors</strong>: To ensure reliable
                obstacle detection and accurate mapping, our team incorporated LIDAR (Light Detection and Ranging)
                sensors into the AMR platform.
              </p>
              <p class="text-[18px] max-md:text-[14px] mt-[5px]">
                - <strong class="text-[18px] max-md:text-[14px]">Following Pre-set Itineraries</strong>: The AMR was
                programmed to follow predefined routes and efficiently adapt to Changes in the environment while
                avoiding obstacles.
              </p>
            </div>
          </div>
          <div class="w-[45%] max-lg:w-full rounded-3xl overflow-hidden max-md:mt-6" data-aos="fade-left">
            <div>
              <nuxt-picture
                loading="lazy"
                src="/images/img-boxxy.png"
                class="w-full picture"
                :imgAttrs="{ class: 'w-full max-lg:h-full max-xl:h-[570px] max-2xl:h-[680px]', alt: 'cammera' }"
              />
            </div>
          </div>
        </div>
      </section>
      <section class="mt-[17px] 2xl:container m-auto">
        <div class="flex max-lg:flex-col max-md:items-center gap-4">
          <div
            class="w-[45%] max-lg:w-full rounded-3xl overflow-hidden max-lg:order-1 max-md:mt-6"
            data-aos="fade-right"
          >
            <nuxt-picture
              loading="lazy"
              src="/images/img-5.png"
              class="w-full picture"
              :imgAttrs="{ class: 'w-full', alt: 'cammera' }"
            />
          </div>
          <div
            class="w-[55%] bg-white rounded-3xl overflow-hidden pl-[58px] pt-[132px] relative max-xl:p-4 max-lg:w-full max-md:mt-6"
            data-aos="fade-left"
          >
            <div class="flex max-md:flex-col max-md:items-start items-center gap-[35.35px] max-xl:gap-3 mt-[25px]">
              <h4 class="text-black font-bold uppercase max-md:text-[18px]">Team Size</h4>
              <p class="text-right text-black text-[18px] max-md:text-[14px]">8 (1 PM, 2 Tech Lead, 5 Developers)</p>
            </div>
            <div class="mt-[20px]">
              <h4 class="text-[#101010] pt-[10px] uppercase max-md:text-[18px]">Support Coverage</h4>
              <p class="text-[18px] text-black pt-3 max-md:text-[14px]">- System Design and Architecture</p>
              <p class="text-[18px] text-black pt-2 max-md:text-[14px]">- Software Development</p>
              <p class="text-[18px] text-black pt-2 max-md:text-[14px]">- Sensor Integration</p>
              <p class="text-[18px] text-black pt-2 max-md:text-[14px]">- Navigation Algorithms</p>
              <p class="text-[18px] text-black pt-2 max-md:text-[14px]">- Monitoring Software</p>
            </div>
          </div>
        </div>
      </section>
    </section>

    <section class="mt-[80px] 2xl:container m-auto max-md:mt-10" data-aos="fade-up" id="internet-of-things-iot">
      <div class="flex max-lg:flex-col max-md:items-center gap-[26px] rounded-3xl pb-20 max-md:pb-5 mb-10 bg-white">
        <div
          class="w-[50%] bg-white rounded-3xl overflow-hidden pt-[62px] pl-[30px] max-lg:pb-0 pb-[20px] relative max-xl:p-4 max-lg:w-full"
        >
          <div class="flex max-md:flex-col gap-[32px] items-center max-md:items-start">
            <nuxt-picture loading="lazy" src="/images/group-75.svg" :imgAttrs="{ alt: 'icon' }" class="w-[85px]"/>
            <p class="uppercase text-[32px] font-bold mt-[8px] max-md:text-[24px]">
              Improving Overall Equipment Effectiveness
            </p>
          </div>
          <div class="pt-[10px] max-md:pt-[20px] font-medium text-[16px] uppercase max-md:text-[12px]">
            Manufacturing, IoT
          </div>
          <div class="">
            <h4 class="text-[#101010] mt-[37px] max-md:mt-[20px] max-md:text-[18px]">ABOUT CLIENT</h4>
            <p class="text-[18px] text-black mt-[37px] max-md:mt-2 max-md:text-[14px]">
              Our client, a leading
              <strong class="text-[18px] max-md:text-[14px]">Japanese plastic molding company</strong>, operated a
              large-scale manufacturing facility with over 200 plastic molding machines from various manufacturers like
              Sumitomo and JSW. They faced difficulties in managing and optimizing their production processes due to the
              <strong class="text-[18px] max-md:text-[14px]">lack of data insights and automation</strong>, including:
            </p>
            <div class="ml-6">
              <p class="text-[18px] mt-[5px] max-md:text-[14px]">
                - <strong class="text-[18px] max-md:text-[14px]">Diverse Machine Models</strong>: This diversity made it
                challenging to establish a unified data collection process.
              </p>
              <p class="text-[18px] max-md:text-[14px] mt-[5px]">
                - <strong class="text-[18px] max-md:text-[14px]">Manual Data Recording</strong>: The client relied on
                manual data recording, resulting in errors, inefficiencies, and an inability to track real-time
                performance metrics.
              </p>
              <p class="text-[18px] mt-[5px] max-md:text-[14px]">
                - <strong class="text-[18px] max-md:text-[14px]">Lack of Real-time Reports</strong>: It prevented the
                client from promptly identifying production issues, leading to delays in resolving problems.
              </p>
              <p class="text-[18px] mt-[5px] max-md:text-[14px]">
                - <strong class="text-[18px] max-md:text-[14px]">No Connection to ERP and MES</strong>: This hindered
                seamless data flow and optimization.
              </p>
            </div>
          </div>
        </div>
        <div class="w-[50%] bg-white rounded-3xl overflow-hidden p-6 relative max-xl:p-4 max-lg:w-full">
          <div class="flex gap-[32px] w-full max-lg:hidden">
            <nuxt-picture
              loading="lazy"
              src="/images/2.png"
              :imgAttrs="{ class: 'w-full', alt: 'icon' }"
              class="w-full"
            />
          </div>
          <div class="ml-3">
            <h4 class="text-[#101010] pt-[33px] max-lg:pt-0 max-md:text-[18px]">SCOPE OF WORK</h4>
            <p class="text-[18px] text-black pt-[24px] max-md:text-[14px]">
              Our team analyzed the client's pain points and devised a comprehensive solution leveraging IoT
              technologies to address their challenges:
            </p>
            <p class="text-[18px] mt-[5px] max-md:text-[14px]">- IoT Device Integration</p>
            <p class="text-[18px] mt-[5px] max-md:text-[14px]">- Data Aggregation and Analytics</p>
            <p class="text-[18px] mt-[5px] max-md:text-[14px]">- Real-time Monitoring and Reporting</p>
            <p class="text-[18px] mt-[5px] max-md:text-[14px]">- ERP and MES Integration</p>
          </div>
        </div>
      </div>

      <div class="w-full hidden max-lg:inline">
        <nuxt-picture loading="lazy" src="/images/2.png" :imgAttrs="{ class: 'w-full', alt: 'icon' }" />
      </div>
    </section>

    <section class="mt-[80px] 2xl:container m-auto max-md:mt-0" id="blockchain">
      <div class="flex max-lg:flex-col max-md:items-center gap-4">
        <div class="w-[45%] max-lg:w-full rounded-3xl overflow-hidden max-md:mt-[24px]" data-aos="fade-right">
          <nuxt-picture
            loading="lazy"
            src="/images/img-6.png"
            class="w-full picture"
            :imgAttrs="{ class: 'w-full max-lg:h-full max-xl:h-[650px] max-2xl:h-[750px]', alt: 'cammera' }"
          />
        </div>
        <div
          class="w-[55%] bg-white rounded-3xl overflow-hidden p-16 relative max-xl:p-4 max-lg:w-full max-md:mt-8"
          data-aos="fade-left"
        >
          <div class="flex max-md:flex-col gap-[32px] items-start">
            <nuxt-picture loading="lazy" src="/images/icons-1.svg" :imgAttrs="{ alt: 'icon' }" class="w-[78px]"/>
            <p class="uppercase font-bold text-[32px] max-md:text-[24px]">FACEGreenUp P2P Blockchain Platform</p>
          </div>
          <div class="pb-[18px] font-medium text-[16px] uppercase mt-4 max-md:text-[12px]">blockchain</div>
          <div class="mb-[20px]">
            <h4 class="text-[#101010] font-bold pt-[10px] uppercase max-md:text-[18px]">About</h4>
            <p class="text-[18px] text-black pt-[25px] max-md:text-[14px] text-justify">
              GreenUp is an energy consulting firm aiming to transform how businesses and homeowners approach energy
              consumption. GreenUp approached us with the vision of creating a P2P energy platform to optimize the
              challenges of high energy costs, insufficient usage, and the pressing need for eco-friendly practices.
            </p>
          </div>
          <div class="mt-[20px]">
            <h4 class="text-[#101010] pt-[10px] uppercase max-md:text-[18px]">Scope of Work</h4>
            <div class="ml-4">
              <p class="text-[18px] text-black pt-3 max-md:text-[14px]">
                - Design and implement and IoT application run on dongle, interact with Smart Meter, automatic energy
                trading based on user preferences.
              </p>
              <p class="text-[18px] text-black pt-2 max-md:text-[14px]">
                - P2P energy platform using blockchain technology of Hyperledger Iroha2
              </p>
              <p class="text-[18px] text-black pt-2 max-md:text-[14px]">
                - Integration: Software module will run at each teller counter’s PC to manage queuing line and call the
                client
              </p>
              <p class="text-[18px] text-black pt-2 max-md:text-[14px]">
                - Dashboard & Web portal for Customers/Utilities: Software module to centralized manage all information
                displayed in TV screens at branch.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Excellence class="mt-[80px]" />
  </div>
</template>
